import { createListenerMiddleware } from "@reduxjs/toolkit";

const listenerMiddleWare = createListenerMiddleware();

export default listenerMiddleWare;

